import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { RecitalDetailsPage } from '~features/recital-manager';

const recitalDetailsSearchParamSchema = z.object({
  tab: z
    .enum([
      'shows',
      'conflicts',
      'sizing',
      'volunteers',
      'check-in',
      'stats',
      'reports',
    ])
    .optional(),
});

const Component = () => {
  const { recitalId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <RecitalDetailsPage recitalId={recitalId} tab={tab} />;
};

export const Route = createFileRoute('/_auth/_layout/recitals/$recitalId/')({
  validateSearch: zodValidator(recitalDetailsSearchParamSchema),
  component: Component,
});
